import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { OfflineBannerState } from '@hunting-nature/Secacam/shared/enums/offline-banner-state.enum';
import { TranslocoPipe } from '@jsverse/transloco';
import { Store } from '@ngrx/store';

import { BannerTranslationKeys } from '../../enums/offline-banner.enum';
import { GeneralSelectors } from '../../redux/general/general.reducer';

@Component({
  selector: 'app-offline-banner',
  standalone: true,
  imports: [CommonModule, TranslocoPipe],
  templateUrl: './offline-banner.component.html',
  styleUrls: ['./offline-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OfflineBannerComponent {
  // services
  private readonly store = inject(Store);

  // UI bindings
  readonly offlineBannerState$$ = this.store.selectSignal(GeneralSelectors.offlineBannerState);

  readonly isVisible$$ = computed(() => this.offlineBannerState$$() !== OfflineBannerState.Hidden);

  readonly message$$ = computed(() => {
    const state = this.offlineBannerState$$();
    const isOnlineState = state === OfflineBannerState.Online || state === OfflineBannerState.OnlineExiting;
    return isOnlineState ? BannerTranslationKeys.ONLINE : BannerTranslationKeys.OFFLINE;
  });
}
